import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { vendorLogin } from '../api/vendorApi';
import VpIcon from '../components/VpIcon';
// @ts-ignore
import neelsLogo from '../../assets/logos/neels_logo.png';

const VendorLogin = () => {
	const navigate = useNavigate();
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [showPassword, setShowPassword] = useState(false);
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);

	const onSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError('');
		if (!username || !password) {
			setError('Please enter your username and password.');
			return;
		}
		setLoading(true);
		try {
			await vendorLogin(username.trim(), password);
			navigate('/vendor-portal/dashboard', { replace: true });
		} catch (err: any) {
			setError(
				err?.apiMessage ||
					err?.response?.data?.message ||
					'Login failed. Please try again.',
			);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className='vp vp-auth'>
			<div className='vp-auth-shell'>
				{/* Left brand panel */}
				<div className='vp-auth-brand'>
					<div className='vp-auth-brand-top'>
						<img className='vp-auth-logo' src={neelsLogo} alt="Neel's Sanjayraj" />
					</div>
					<div className='vp-auth-brand-mid'>
						<h1>Vendor Portal</h1>
						<p>
							Your single place to review requisitions, submit quotations and manage
							challans &amp; invoices — fast, simple and transparent.
						</p>
						<ul className='vp-auth-features'>
							<li>
								<span className='vp-auth-dot'>
									<VpIcon name='requisitions' size={17} />
								</span>{' '}
								See requisitions assigned to you
							</li>
							<li>
								<span className='vp-auth-dot'>
									<VpIcon name='quotations' size={17} />
								</span>{' '}
								Submit quotations with live totals
							</li>
							<li>
								<span className='vp-auth-dot'>
									<VpIcon name='challans' size={17} />
								</span>{' '}
								Upload challans &amp; invoices
							</li>
						</ul>
					</div>
					<div className='vp-auth-brand-foot'>
						&copy; {new Date().getFullYear()} Neel&apos;s Sanjayraj · Vendor Portal
					</div>
				</div>

				{/* Right form panel */}
				<div className='vp-auth-form'>
					<div className='vp-auth-form-inner'>
						<div className='vp-auth-badge'>Welcome back</div>
						<h2>Sign in to your account</h2>
						<p className='vp-auth-sub'>
							Enter the credentials shared with you by the company.
						</p>

						{error && (
							<div className='vp-alert vp-alert-error' role='alert'>
								{error}
							</div>
						)}

						<form onSubmit={onSubmit} noValidate>
							<div className='vp-field'>
								<label className='vp-label' htmlFor='vp-username'>
									Username
								</label>
								<div className='vp-input-wrap'>
									<span className='vp-input-icon'>
										<VpIcon name='profile' size={16} />
									</span>
									<input
										id='vp-username'
										className='vp-input vp-input-icon-pad'
										value={username}
										onChange={(e) => setUsername(e.target.value)}
										placeholder='Enter your username'
										autoComplete='username'
										autoFocus
									/>
								</div>
							</div>

							<div className='vp-field'>
								<label className='vp-label' htmlFor='vp-password'>
									Password
								</label>
								<div className='vp-input-wrap'>
									<span className='vp-input-icon'>
										<VpIcon name='lock' size={16} />
									</span>
									<input
										id='vp-password'
										className='vp-input vp-input-icon-pad'
										type={showPassword ? 'text' : 'password'}
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										placeholder='Enter your password'
										autoComplete='current-password'
									/>
									<button
										type='button'
										className='vp-input-eye'
										onClick={() => setShowPassword((s) => !s)}
										aria-label={showPassword ? 'Hide password' : 'Show password'}>
										<VpIcon name={showPassword ? 'hide' : 'show'} size={17} />
									</button>
								</div>
							</div>

							<button
								type='submit'
								className='vp-btn vp-btn-primary vp-btn-block vp-btn-lg'
								disabled={loading}>
								{loading ? 'Signing in…' : 'Sign In'}
							</button>
						</form>

						<p className='vp-auth-help'>
							Trouble logging in? Contact the company for your credentials.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default VendorLogin;
